import { render, staticRenderFns } from "./OptimizerSettingsCard.vue?vue&type=template&id=56190d92&"
import script from "./OptimizerSettingsCard.vue?vue&type=script&lang=js&"
export * from "./OptimizerSettingsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports